export const C = {
  bg: '#FDFBF7', cream: '#F5F0E8', card: '#FFFFFF', border: '#E8E3DB',
  borderLight: '#F0EBE3', text: '#1A1A18', textSec: '#6A6560', muted: '#9A9590',
  accent: '#C67A5C', green: '#5A8C6A', greenBg: '#EBF3EE', gold: '#C6A05C',
  goldBg: '#FFF8ED', warmStart: '#F9E8D9', warmEnd: '#F5DFC9',
};

export const HERO_IMG = '/food-images/hero_spread.png';
